import { useMemo } from 'react';
import DynamicFormBuilder from '../components/admin/DynamicFormBuilder';
import { getAdminTaskForm, saveAdminTaskForm } from '../services/adminService';

function AdminApplyTask() {
  const defaultForm = useMemo(
    () => ({
      title: 'Task Completion Form',
      status: 'draft',
      introTitle: 'Task Completion Form',
      introDescription:
        'This form is for selected candidates invited to the paid task round. Please use the same email address you used while submitting your job application.',
      categories: [],
    }),
    []
  );

  return (
    <DynamicFormBuilder
      defaultForm={defaultForm}
      eyebrow="Apply Task"
      heading="Task Completion Form"
      loadForm={getAdminTaskForm}
      pageClassName="admin-apply-task-page"
      saveForm={saveAdminTaskForm}
      saveSuccessMessage="Task completion form saved."
      showIntroFields
    />
  );
}

export default AdminApplyTask;
